var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"down-box"},[_c('p',{staticClass:"tip-m"},[_vm._v("推荐您在“"),_c('span',{on:{"click":_vm.downLoad}},[_vm._v("大国工匠客户端")]),_vm._v("”中下载模型！")])])
}
var staticRenderFns = []

export { render, staticRenderFns }